@if (isChangeApprovalRequest && changeMetadata) {
  <div class="change-approval-card">
    <p class="change-title">Proposed Service Changes</p>
    @if (changeMetadata.addedServices.length > 0) {
      <p class="change-section-label">Added</p>
      @for (svc of changeMetadata.addedServices; track svc.id) {
        <p class="change-service added">+ {{ svc.name }} &mdash; {{ formatUSD(svc.price ?? 0) }}</p>
      }
    }
    @if (changeMetadata.removedServices.length > 0) {
      <p class="change-section-label">Removed</p>
      @for (svc of changeMetadata.removedServices; track svc.id) {
        <p class="change-service removed">- {{ svc.name }} &mdash; {{ formatUSD(svc.price ?? 0) }}</p>
      }
    }
    @if (changeMetadata.status === 'pending') {
      @if (isStaffApp) {
        <p class="change-status awaiting">Awaiting customer response</p>
      } @else {
        <div class="change-actions">
          <button
            mat-flat-button
            color="warn"
            [disabled]="actionLoading()"
            (click)="reject()">
            Reject
          </button>
          <button
            mat-flat-button
            color="primary"
            [disabled]="actionLoading()"
            (click)="approve()">
            Approve
          </button>
        </div>
      }
    } @else if (changeMetadata.status === 'stale') {
      <p class="change-status stale">Dismissed &mdash; superseded by a new change request</p>
    } @else {
      <p class="change-status">{{ changeMetadata.status | titlecase }}</p>
    }
  </div>
} @else {
  <p class="message">{{ message.content }}</p>
}
@if (showTime) {
  <p class="time">{{ formatMessageTimestamp(message.sentAt) }}</p>
}
@if (message.readAt && showRead) {
  <p class="read">Read</p>
}
